import Carousel from './components/Carousel.js';
import Header from './components/Header.js';
export default class ComponentFactory {
  constructor() {
    this.componentList = {
      Carousel,
      Header,
    };
    this.init();
  }
  init() {
    const components = document.querySelectorAll('[data-component]');

    for (let i = 0; i < components.length; i++) {
      const element = components[i];
      const componentName = element.dataset.component;

      if (this.componentList[componentName]) {
        const instance = new this.componentList[componentName](element);
      } else {
        console.log(`La composante ${componentName} n'existe pas`);
      }
    }
  }
}
